import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const h = () => setScrolled(window.scrollY > 30); window.addEventListener('scroll', h, { passive: true }); return () => window.removeEventListener('scroll', h); }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all ${scrolled ? 'bg-[#F5EFDF]/95 backdrop-blur-md py-3 border-b border-[#4A1A2C]/15' : 'bg-transparent py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid grid-cols-[1fr_auto_1fr] items-center gap-6">
        <div className="hidden md:block font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9A574]">— Cap Ferrat · Est. {META.est}</div>
        <button onClick={() => setPage('home')} data-testid="aur-logo" className={`text-center ${scrolled ? 'text-[#4A1A2C]' : 'text-[#F5EFDF]'}`}><p className="font-serif italic text-[34px] leading-none">{META.brand}</p><p className="font-mono text-[8px] tracking-[0.55em] uppercase opacity-70 mt-1">— Resort & spa —</p></button>
        <nav className="hidden md:flex items-center justify-end gap-7">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`aur-nav-${r.id}`} className={`group flex items-baseline gap-1.5 transition-colors ${page === r.id ? 'text-[#C9A574]' : (scrolled ? 'text-[#4A1A2C]/65 hover:text-[#4A1A2C]' : 'text-[#F5EFDF]/75 hover:text-[#F5EFDF]')}`}>
              <span className="font-mono text-[9px] tracking-[0.32em] opacity-50 group-hover:opacity-100">{r.no}</span>
              <span className="font-serif italic text-base" dangerouslySetInnerHTML={{ __html: r.label }} />
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
